import { render, staticRenderFns } from "./pay-qrcode.vue?vue&type=template&id=236b5cd3&"
import script from "./pay-qrcode.vue?vue&type=script&lang=js&"
export * from "./pay-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./pay-qrcode.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports